import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BackArrow.css';

function BackArrow({ to, color = 'hellblau', onBeforeNavigate }) {
  const navigate = useNavigate();

  return (
    <div
      className={`back-arrow ${color}`}
      onClick={() => {
        if (!onBeforeNavigate || onBeforeNavigate()) {
          navigate(to);
        }
      }}
    >
      <span className="material-symbols-outlined">arrow_back</span>
      <span className="back-text">ZURÜCK</span>
    </div>
  );
}

export default BackArrow;
